import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PopMastrService {
  // private apiUrl = "https://lexipackghana.com:3003/api";
  apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  masterMaterial(data:any){
    return this.http.post(this.apiUrl+'/masterMaterial',data);
  }
  getMasterMaterial(){
    return this.http.get(this.apiUrl+'/materialMasterList');
  }
  getMaterialMasterById(id: string) {
    return this.http.get(this.apiUrl + '/materialMaster/' + id);
  }
  updateMasterMaterial(id: string, data: any) {
    return this.http.put(this.apiUrl + '/materialMaster/' + id, data);
  }
}